var v1="<div class=\"checkbox\"> <label for=\"{{ vm.settings.dataAt }}\"> <input type=\"checkbox\" name=\"{{ vm.settings.dataAt }}\" id=\"{{ vm.settings.dataAt }}\" ng-model=\"vm.data\" ng-disabled=\"vm.settings.disabled\" ng-required=\"vm.settings.required\">\n{{ vm.settings.displayName }} </label> <p class=\"help-block\" ng-if=\"vm.settings.helpText\">{{ vm.settings.helpText }}</p> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaBoolean/lbaBoolean.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaBoolean/lbaBoolean.html
// module id = 245
// module chunks = 0